import React from "react";

const ContextUser = React.createContext({
  user: { id: "", name: "" },
  setUser: null,
});

export default ContextUser;
